<template>
  <div class="wrapper-content-item-type">
    <span v-for="itemType in listType"
          class="py-1">
      <v-menu
        bottom
        offset-y
        content-class="menu-dropdown-school-level"
      >
        <template v-slot:activator="{ on, attrs }">
          <span
            :class="itemType.id == filterForm.typeId ? 'item-type item-type-selected' : 'item-type'"
            color="primary"
            dark
            v-bind="attrs"
            @click="selectType(itemType)"
            v-on="on"
          >
            {{itemType.name}}
          </span>
        </template>

        <v-list v-if="itemType.id" class="module-menu">
          <v-list-item
            v-for="(item, index) in listSchoolLevelByType"
            :key="index"
            @click="selectSchoolLevel(item)"
          >
            <v-list-item-title
                :class="item.id == filterForm.schoolLevelId && itemType.id == filterForm.typeId ?
                'item-school-level-selected' : 'item-school-level'"
            >{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      listType: {
        type: Array,
        default: () => []
      },
      listSchoolLevel: {
        type: Array,
        default: () => []
      },
      filterForm: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        openToolbar: false,
        currentTypeId: ''
      }
    },
    computed:{
        listSchoolLevelByType() {
        if(this.listSchoolLevel.length > 0 && this.currentTypeId){
            const result = this.listSchoolLevel.find(school => school.id === this.currentTypeId)
            return result.schoolLevel
        } else return []
      }
    },
    methods: {
      selectSchoolLevel(itemSch) {
        this.filterForm.schoolLevelId = itemSch.id
        this.filterForm.typeId = this.currentTypeId
        this.filterForm.statusIds = []
        this.openFormDashboard = false
        Bus.$emit('search-allotment-list', this.filterForm)
      },
      selectType(itemType) {
        this.currentTypeId = itemType.id
      }
    }
  }
</script>

<style scoped lang="css">
  .v-text-field {
    padding-top: 0px !important;
  }
  .item-type-selected {
    background: #7E75DD;
    color: #FFFFFF !important;
  }
  .wrapper-content-item-type {
    border: 8px solid #D7D3F2;
    overflow-y: hidden;
    border-radius: 10px;
    width: fit-content;
    margin: 0 auto;
    font-size: 18px;
  }
  .menu-dropdown-school-level {
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  .item-type {
    min-width: 175px;
    display: inline-block;
    text-align: center;
    width: fit-content;
    padding: 5px 10px;
    color: #B9B9B9;
    border-right: 1px solid #D7D3F2;
  }
  /deep/ .module-menu.v-list {
    background: #d7d3f2;
  }
  /deep/.item-school-level-selected {
    color: #4C458D !important;
    font-size: 18px !important;
  }
  /deep/.item-school-level {
    font-weight: unset !important;
    color: #8C8C8C !important;
    font-size: 18px !important;
  }
</style>